export function getAllNestedParams(
  url: string,
  outerParam: string
): Record<string, string> {
  try {
    const outerUrl = new URL(url, window.location.origin);
    const nestedUrlString = outerUrl.searchParams.get(outerParam);

    if (!nestedUrlString) return {};

    const decodedNestedUrl = decodeURIComponent(nestedUrlString);
    const nestedUrl = new URL(decodedNestedUrl);

    const result: Record<string, string> = {};
    nestedUrl.searchParams.forEach((value, key) => {
      result[key] = value;
    });

    return result;
  } catch (err) {
    console.error("Failed to parse all nested params:", err);
    return {};
  }
}
